//@flow
import qs from "qs"

const parseQueryString = (state: any, key: string): string => {
  const search =
    state.routing && state.routing.location && state.routing.location.search
  const query = search ? qs.parse(search.replace(/^\?/, "")) : {}
  return query[key] || ""
}

export default parseQueryString



// WEBPACK FOOTER //
// ./src/RoutingHelpers/parseQueryString.js